/* The last guard on the countdown: never let it show a deadline that has passed.
 *
 * Liquid already refuses to draw an expired one, but Liquid runs when the page
 * is rendered and the page can outlive that: served from cache a few minutes
 * later, or simply left open on a phone overnight. The theme's own
 * <countdown-timer> freezes at zero in that case, and a timer frozen at zero is
 * exactly what this whole feature was built to remove.
 *
 * So the timer is taken away — the timer, never the section. The theme's
 * `expiration-behavior="hide"` removes the closest `.shopify-section`, which
 * from inside a product block would take the product page with it.
 */
(function () {
  var SELECTOR = '.sale-line__timer[expires-at]';
  // setTimeout silently fires at once past this, which would hide a countdown
  // three weeks out the moment it appeared.
  var MAX_DELAY = 2147483000;

  function retire(timer) {
    if (!timer || !timer.parentNode) return;
    var line = timer.closest ? timer.closest('.sale-line') : null;
    timer.parentNode.removeChild(timer);
    if (line) line.classList.remove('sale-line--with-timer');
  }

  function watch(timer) {
    if (timer.getAttribute('data-sale-watched') === 'true') return;
    timer.setAttribute('data-sale-watched', 'true');

    var ends = Date.parse(timer.getAttribute('expires-at'));
    if (!isFinite(ends)) return retire(timer);

    var left = ends - Date.now();
    if (left <= 0) return retire(timer);
    if (left > MAX_DELAY) return;

    window.setTimeout(function () { retire(timer); }, left + 1000);
  }

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // The variant picker re-renders the price block, and the sale line with it.
  document.addEventListener('variant:change', scan);
  document.addEventListener('variant:update', scan);
})();
